export enum TicketPrintOptions {
  PRINT = 'PRINT',
  PRINT_WITHOUT_TOTAL_AMOUNT = 'PRINT_WITHOUT_TOTAL_AMOUNT',
}
